<template>
<div class="outer">
	<div class="middle">
		<div class="inner" style="width: 290px">
			<el-card style="width: 290px" v-loading="loading">
				<el-form :model="loginForm" :rules="rulesLogin" label-position="top" ref="loginForm" label-width="120px" v-show="status == 'login'">
					<el-form-item label="Usuario" prop="user">
						<el-input v-model="loginForm.user"></el-input>
					</el-form-item>
					<el-form-item label="Contraseña" prop="pass">
						<el-input type="password" v-model="loginForm.pass"></el-input>
					</el-form-item>
						<el-form-item style="text-align: center">
						<el-button type="primary" @click="submitForm('loginForm')">Ingresar</el-button>
						<el-button @click="status = 'reg'">Registrarse</el-button>
					</el-form-item>
				</el-form>

				<el-form :model="registerForm" :rules="rulesRegister" label-position="top" ref="registerForm" label-width="120px" v-show="status == 'reg'">
					<el-form-item label="Email" prop="mail">
						<el-input type="mail" v-model="registerForm.mail"></el-input>
					</el-form-item>
					<el-form-item label="Usuario" prop="user">
						<el-input v-model="registerForm.user"></el-input>
					</el-form-item>
					<el-form-item label="Contraseña" prop="pass">
						<el-input type="password" v-model="registerForm.pass"></el-input>
					</el-form-item>
					<el-form-item label="Servidor" prop="server">
						<el-select v-model="registerForm.server" placeholder="Server" style="width: 100%">
							<el-option label="LAS" value="LA2"></el-option>
							<el-option label="LAN" value="LA1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Summoner" prop="summoner">
						<el-input v-model="registerForm.summoner"></el-input>
					</el-form-item>
					<el-form-item style="text-align: center">
						<el-button type="primary" @click="submitForm('registerForm')">Registrarse</el-button>
						<el-button @click="status = 'login'">Ingresar</el-button>
					</el-form-item>
				</el-form>
			</el-card>
		</div>
	</div>
</div>
</template>

<script>

import { mapActions } from 'vuex'

/*const axios_base = require('axios');
const axios = axios_base.create({
    //baseURL: 'http://driconmax.com.ar/TridyGeeks/',
    headers : {
        //'Content-Type' : 'multipart/form-data; charset=UTF-8'
    }
});*/

import axios from 'axios';

export default {
	name: 'home',
	components: {

	},
	data() {
		return {
			status: 'login',
			loading: false,
			loginForm: {
				user: '',
				pass: ''
			},
			registerForm: {
				mail: '',
				user: '',
				pass: '',
				server: 'LA2',
				summoner: ''
			},
			rulesLogin: {
				user: [
					{ required: true, message: 'Ingrese un usuario', trigger: 'blur' },
					{ min: 5, message: 'El usuario tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
				pass: [
					{ required: true, message: 'Ingrese una contraseña', trigger: 'blur' },
					{ min: 5, message: 'La contraseña tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
			},
			rulesRegister: {
				mail: [
					{ required: true, message: 'Ingrese un email', trigger: 'blur' },
					{ type: 'email', message: 'Ingrese un email valido', trigger: ['blur', 'change'] }
				],
				user: [
					{ required: true, message: 'Ingrese un usuario', trigger: 'blur' },
					{ min: 5, message: 'El usuario tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
				pass: [
					{ required: true, message: 'Ingrese una contraseña', trigger: 'blur' },
					{ min: 5, message: 'La contraseña tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
				server: [
					{ required: true, message: 'Seleccione un servidor', trigger: 'change' }
				],
				summoner: [
					{ required: true, message: 'Ingrese su nombre de invocador', trigger: 'blur' }
				]
			}
		};
	},
	methods: {
		...mapActions([
			'login'
		]),
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			if (valid) {
				
				this.loading = true;
				switch (this.status) {
					case "login":
						axios({
							method: 'post',
							url: '/server/login.php?action=login',
							data: {
								username: this.loginForm.user,
								password: this.loginForm.pass
							}
						}).then((response) => {
							if(response.data.error != 0){
								this.$notify.error({
									title: 'Error',
									message: response.data.message,
									offset: 115
								});
							} else {
								this.login({username: response.data.user.username, img: ''});
								if(this.$route.query.redirect != undefined){
									this.$router.push(this.$route.query.redirect)
								} else {
									this.$router.push('/')
								}
							}
						})
						.catch(this.catchAxios)
						.then(() => {
							this.loading = false;
						});
						break;

					case "reg":
						axios({
							method: 'post',
							url: '/server/login.php?action=register',
							data: {
								mail: this.registerForm.mail,
								username: this.registerForm.user,
								password: this.registerForm.pass,
								server: this.registerForm.server,
								summoner: this.registerForm.summoner
							}
						}).then((response) => {
							if(response.data.error != 0){
								this.$notify.error({
									title: 'Error',
									message: response.data.message,
									offset: 115
								});
							} else {
								this.status = "login";
								this.resetForm(formName);

							}
						})
						.catch(this.catchAxios)
						.then(() => {
							this.loading = false;
						});
						break;
				
					default:
						this.loading = false;
						break;
				}
				
				//console.log(this.$route.query);
			} else {
				this.$notify.error({
					title: 'Error',
					message: 'Campos incorrectos',
					offset: 115
				});
				return false;
			}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		catchAxios(error){
			console.log(error);
		}
	}
}
</script>

<style>
	.el-form--label-top .el-form-item__label {
		padding-bottom: 0px;
		line-height: 25px;
	}
</style>

<style scoped>

	.outer {
		display: table;
		position: absolute;
		height: calc(100% - 115px);
		width: 99%;
	}
	
	.middle {
		display: table-cell;
		vertical-align: middle;
	}

	.inner {
		margin-left: auto;
		margin-right: auto;
		width: 400px;
		text-align: initial;
	}
</style>